import { useMemo } from "react"

import { slackDomain } from "@/screens/settings/integrations/slack-channel-list"
import { api } from "./api"
import { useSlackConnections } from "./zero"

export interface SlackWorkspaceOption {
	id: string
	name: string
	iconUrl: string | null
}

/** Connected Slack workspaces with their Slack name and logo; the domain stands in until Slack answers. */
export function useSlackWorkspaceOptions(): SlackWorkspaceOption[] {
	const connections = useSlackConnections()
	const teams = api.workspace.slackTeams.useQuery(undefined, {
		enabled: connections.length > 1,
		staleTime: 60 * 60_000,
		cacheTime: 60 * 60_000,
	})
	return useMemo(
		() =>
			connections.map((connection) => {
				const team = teams.data?.find((row) => row.id === connection.id)
				return {
					id: connection.id,
					name: team?.name ?? slackDomain(connection.teamUrl),
					iconUrl: team?.iconUrl ?? null,
				}
			}),
		[connections, teams.data],
	)
}
